import axios from 'axios';

// All API calls are prefixed with /api — the ALB routes /api/* to the API target group
const BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  login: (email, password) => api.post('/api/auth/login', { email, password }),
  me: () => api.get('/api/auth/me'),
  changePassword: (current_password, new_password) =>
    api.post('/api/auth/change-password', { current_password, new_password }),
  listTenants: () => api.get('/api/auth/tenants'),
  validateInviteToken: (token) => api.get(`/api/auth/invite/validate?token=${token}`),
  setPassword: (token, password, confirm_password) =>
    api.post('/api/auth/set-password', { token, password, confirm_password }),
  forgotPassword: (email) => api.post('/api/auth/forgot-password', { email }),
};

export const ftpApi = {
  getConfig: () => api.get('/api/ftp/config'),
  saveConfig: (data) => api.put('/api/ftp/config', data),
  testConnection: (data) => api.post('/api/ftp/test', data),
};

export const jobsApi = {
  getDashboard: () => api.get('/api/jobs/dashboard'),
  list: (limit = 50, offset = 0) => api.get(`/api/jobs?limit=${limit}&offset=${offset}`),
  get: (id) => api.get(`/api/jobs/${id}`),
  trigger: () => api.post('/api/jobs/trigger'),
};

export const adminApi = {
  listTenants:       ()           => api.get('/api/admin/tenants'),
  createTenant:      (data)       => api.post('/api/admin/tenants', data),
  toggleTenant:      (id)         => api.patch(`/api/admin/tenants/${id}/toggle-active`),
  deleteTenant:      (id)         => api.delete(`/api/admin/tenants/${id}`),
  listTenantUsers:   (tenantId)   => api.get(`/api/admin/tenants/${tenantId}/users`),
  createTenantUser:  (tenantId, data) => api.post(`/api/admin/tenants/${tenantId}/users`, data),
  deleteTenantUser:  (tenantId, userId) => api.delete(`/api/admin/tenants/${tenantId}/users/${userId}`),
  sendInvite:        (tenantId, userId) => api.post(`/api/admin/tenants/${tenantId}/users/${userId}/invite`),
  getInviteStatus:   (tenantId, userId) => api.get(`/api/admin/tenants/${tenantId}/users/${userId}/invite-status`),
};

export default api;

export const sftpApi = {
  getConfig: () => api.get('/api/sftp/config'),
  updateConfig: (data) => api.put('/api/sftp/config', data),
  provision: () => api.post('/api/sftp/provision'),
  deprovision: () => api.delete('/api/sftp/deprovision'),
  getPrivateKey: () => api.get('/api/sftp/private-key'),
  rotateKey: () => api.post('/api/sftp/rotate-key'),
  listFiles: (limit = 50) => api.get(`/api/sftp/files?limit=${limit}`),
  getDownloadUrl: (fileId) => api.get(`/api/sftp/files/${fileId}/download`),
};

export const mappingsApi = {
  list:         ()                     => api.get('/api/mappings'),
  update:       (fileType, data)       => api.put(`/api/mappings/${fileType}`, data),
  testPattern:  (data)                 => api.post('/api/mappings/test', data),
};

export const administratorsApi = {
  list:       ()              => api.get('/api/admin/administrators'),
  create:     (data)          => api.post('/api/admin/administrators', data),
  sendInvite: (adminId)       => api.post(`/api/admin/administrators/${adminId}/invite`),
  remove:     (adminId)       => api.delete(`/api/admin/administrators/${adminId}`),
};
